module.exports = __webpack_public_path__ + "static/media/report_finance.13ee03d3.svg";